import { FC } from "react";
import { NOT_ELIGIBLE_LAW_FIRM_TEXT } from "../../eligibility/participantEligibilityUi";

type IneligibleLawFirmNoticeProps = {
  title: string;
};

export const IneligibleLawFirmNotice: FC<IneligibleLawFirmNoticeProps> = ({
  title,
}) => (
  <>
    <p className="small fw-semibold text-muted">{title}</p>
    <p className="small text-muted text-wrap">{NOT_ELIGIBLE_LAW_FIRM_TEXT}</p>
  </>
);
